<template>
<div v-if="!isMobile()">
  <div class="section section-landfeatures" id="landfeatures-section" data-background-color="white">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-12">
          <h1 data-aos="fade-up" class="title deco1">{{$t(`Features`)}}</h1>
          <div class="space-50"></div>
          <div class="row" style="padding-bottom: 60px;">
            <div data-aos="fade-right" data-aos-offset="-100" class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_07.png'" width="100%" height="100%" />
            </div>
            <div data-aos="fade-left" data-aos-offset="-100" class="col-md-6" style="background-image: url('/img/bg_game_02.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;">
              <h5 class="description-land-title text-left" style="padding-left: 20px; padding-top:50px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`land features title 1`)}}</h5>
              <h5 class="description-land-desc text-left" style="padding-left: 20px;">{{$t(`land features desc 1`)}}</h5>
            </div>
          </div>
          <div class="row" style="padding-bottom: 60px;">
            <div data-aos="fade-right" data-aos-offset="-200" class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_08.png'" width="100%" height="100%" />
            </div>
            <div data-aos="fade-left" data-aos-offset="-200" class="col-md-6" style="background-image: url('/img/bg_game_02.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;">
              <h5 class="description-land-title text-left" style="padding-left: 20px; padding-top:50px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`land features title 2`)}}</h5>
              <h5 class="description-land-desc text-left" style="padding-left: 20px;">{{$t(`land features desc 2`)}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div v-else>
  <div class="section-m section-landfeatures" id="landfeatures-section" data-background-color="white">
    <div class="container" style="width: 85%;">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-12">
          <h1 class="title-m deco1">{{$t(`Features`)}}</h1>
          <div class="row" style="padding-bottom: 20px; ">
            <div class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_07.png'" width="100%" height="100%" />
            </div>
            <div style="background-image: url('/img/bg_game_02.png'); min-height: 200px; background-size: cover; background-repeat: no-repeat;">
              <div style="width: 90%; height: 90%; margin: auto;">
                <h5 class="description-land-title-m text-left" style="padding-top:40px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`land features title 1`)}}</h5>
                <h5 class="description-land-desc-m text-left">{{$t(`land features desc 1`)}}</h5>                
              </div>              
            </div>
          </div>
          <div class="row" style="padding-bottom: 20px;">
            <div class="col-md-6" style="padding: 0;">
              <img v-lazy="'/img/img_game_08.png'" width="100%" height="100%" />
            </div>
            <div style="background-image: url('/img/bg_game_02.png'); min-height: 200px; background-size: cover; background-repeat: no-repeat;">
              <div style="width: 90%; height: 90%; margin: auto;">
                <h5 class="description-land-title-m text-left" style="padding-top:40px;"><img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" /> {{$t(`land features title 2`)}}</h5>
                <h5 class="description-land-desc-m text-left">{{$t(`land features desc 2`)}}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style></style>
